import React from 'react'
import styled from 'styled-components'
import EditTeacherModal from 'modules/teachers/components/EditTeacherModal'
import DeleteTeacherModal from 'modules/teachers/components/DeleteTeacherModal'
import Checkbox from 'components/Checkbox'
import { propOr } from 'ramda'
import { redirect } from 'utils/navigation'

const TeachersTableRow = ({ teacher, order, isSelected, onSelect }) => {
  const handleCheckboxChange = (_, checked) => {
    onSelect(teacher.id, checked)
  }

  const handleRowClick = () => {
    redirect(`/teachers/${teacher.id}`)
  }
  return (
    <Wrapper>
      <td onClick={e => e.stopPropagation()}>
        <CheckboxWrapper>
          <Checkbox
            value={isSelected}
            onChange={handleCheckboxChange}
          />
        </CheckboxWrapper>
      </td>
      <td onClick={handleRowClick}>{order}.</td>
      <td onClick={handleRowClick}>{propOr('---', 'name', teacher)}</td>
      <td onClick={handleRowClick}>{propOr('---', 'email', teacher)}</td>
      <td onClick={handleRowClick}>{propOr('---', 'phoneNumber', teacher)}</td>
      <td>
        <Actions onClick={e => e.stopPropagation()}>
          <EditTeacherModal teacher={teacher} />
          <DeleteTeacherModal teacher={teacher} />
        </Actions>
      </td>
    </Wrapper>
  )
}

export default TeachersTableRow

const Wrapper = styled.tr`
  transition: all .3s;
  font-size: 14px;
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey};
    cursor: pointer;
  }
`

const Actions = styled.div`
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
`
